import { SetPasswordForm } from "@/features/user/forms/set-password-form";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/setpassword/$id")({
  head: () => appTitleHead("password-header-reset"),
  component: SetPasswordPage
});

function SetPasswordPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  return (
    <div className="block w-full max-w-full pt-0 md:flex md:items-start md:justify-center">
      <div className="container mx-auto px-4 py-4 md:py-8">
        <h1 className="hidden text-left md:block">{t("password-new")}</h1>
        <p className="max-w-[800px]">{t("password-new-description")}</p>
        <SetPasswordForm />
      </div>
    </div>
  );
}
